import React from "react";
import BoxplotMultiple from "./BoxplotMultiple";
import LineChartOrdinal from "./LineChartOrdinal";

const DistributionPlot = ({ plotMode, ...props }) => {
  if (plotMode === "boxplot") {
    return <BoxplotMultiple {...props} />;
  }
  return <LineChartOrdinal {...props} />;
};

export default DistributionPlot;
